import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../../BASEURL";

export default function AddAddress() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    city: "",
    address: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(`${BASE_URL}/api/address`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed to save address");
      setSuccess("Address saved successfully!");
      setForm({ city: "", address: "", phone: "" });
      setTimeout(() => navigate(-1), 1200);
    } catch (err) {
      setError(err.message || "Failed to save address");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6 text-primary">Add New Address</h1>

      <div className="bg-white p-6 rounded shadow space-y-4">
        {error && <p className="text-red-500 mb-2">{error}</p>}
        {success && <p className="text-green-600 mb-2">{success}</p>}
        <input
          className="w-full border p-2 rounded"
          placeholder="Branch Name (e.g. Rajkot Office)"
          value={form.city}
          onChange={(e) => handleChange("city", e.target.value)}
        />

        <textarea
          className="w-full border p-2 rounded"
          placeholder="Full Address"
          value={form.address}
          onChange={(e) => handleChange("address", e.target.value)}
        />

        <input
          className="w-full border p-2 rounded"
          placeholder="Phone Number"
          value={form.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
        />

        <div className="flex justify-end gap-3">
          <button onClick={() => navigate(-1)} className="border px-4 py-2 rounded">
            Cancel
          </button>
          <button
            className="bg-primary text-white px-6 py-2 rounded"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Address"}
          </button>
        </div>
      </div>
    </div>
  );
}
